import type { Availability } from '@cocoonspace/sdk-js/types/availability'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Trans, useTranslation } from 'next-i18next'
import { Price } from '~/components/price'

import { InfoPopover } from '~/components/atoms/info-popover'

export interface FooterPriceCreateProps {
	availability: Availability
}

export const FooterPriceCreate = ({ availability }: FooterPriceCreateProps) => {
	const { t, i18n } = useTranslation()

	return (
		<div>
			<div className='flex flex-row items-center gap-1 text-sm'>
				{t('common:thatIs')}

				<Price
					price={availability?.price_hour}
					crossed={availability?.price_hour_discounted !== undefined}
					className='font-normal'
				/>

				{availability?.price_hour_discounted !== undefined && (
					<Price
						price={availability?.price_hour_discounted}
						className='text-primary'
					/>
				)}

				<div>x</div>

				{dateTimeUtils
					.duration(availability?.billed_minutes || 0, 'minutes')
					.format(t('common:dateTimes.hourFormat') as string)}

				{availability?.price_hour_discounted !== undefined &&
					i18n.exists(
						`promotions:rebate_codes.${availability?.rebate_codes?.[0]}`,
					) && (
						<InfoPopover>
							<Trans
								i18nKey={`promotions:rebate_codes.${availability?.rebate_codes?.[0]}`}
							/>
						</InfoPopover>
					)}
			</div>

			{availability?.price > 0 ? (
				<div>
					<Price
						data-testid='due-price'
						price={availability?.price}
						taxType='ht'
						taxClassName='mb-[1px] text-xxs font-normal'
					/>
				</div>
			) : (
				<div
					data-testid='free-price'
					className='font-bold'
				>
					{t('common:free')}
				</div>
			)}
		</div>
	)
}
